import api from './httpService';

export const addMemberService = async (payload: any) => {
    const response = await api.post('/members', payload); // assuming you're using axios
    return response.data;
};

export const getMembers = async (params?: {
    page?: number;
    limit?: number;
    search?: string;
    gender?: string;
    branch?: string;
    memberType?: string;
    status?: string;
}) => {
    const qs = new URLSearchParams();
    if (params?.page) qs.set("page", String(params.page));
    if (params?.limit) qs.set("limit", String(params.limit));
    if (params?.search) qs.set("search", params.search);
    if (params?.gender) qs.set("gender", params.gender);
    if (params?.branch) qs.set("branch", params.branch);
    if (params?.memberType) qs.set("memberType", params.memberType);
    if (params?.status) qs.set("status", params.status);

    const query = qs.toString();
    const response = await api.get(`/members${query ? `?${query}` : ""}`);
    return response.data;
};

export const updateMemberService = async (memberId: string, payload: any) => {
    const response = await api.put(`/members/${memberId}`, payload);
    return response.data;
};

export const deleteMemberService = async (memberId: string) => {
    const response = await api.delete(`/members/${memberId}`);
    return response.data;
};
